import { AliceSDKProvider } from '@alice-financial/alice-sdk'
import { StatusNotification, ThemeProvider } from '@alice-financial/pretext-ui'
import * as React from 'react'
import { HelpScoutBeacon } from './app/auth/helpScout/beacon'
import { SessionManager } from './app/auth/SessionManager'
import { Router } from './app/routes/Router'
import { SessionProfileProvider } from './app/user/sessionProfile/SessionProfileContext'
import { localizationProps } from './translations/localizationProps'

export const AppRoot: React.FC = () => {
  return (
    <React.StrictMode>
      <ThemeProvider>
        <AliceSDKProvider {...localizationProps}>
          <SessionProfileProvider>
            <SessionManager>
              <StatusNotification />
              <Router />
              <HelpScoutBeacon />
            </SessionManager>
          </SessionProfileProvider>
        </AliceSDKProvider>
      </ThemeProvider>
    </React.StrictMode>
  )
}
